var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import { ButtonSize } from "../Button";
export const ButtonGroup = (_a) => {
    var { children = [], className, size = ButtonSize.Small, align = "left" } = _a, props = __rest(_a, ["children", "className", "size", "align"]);
    const classes = classNames("gerudo-btn-grp", `align-${align}`, className, size);
    const elements = React.Children.toArray(children).map((e) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return React.cloneElement(e, { size });
    });
    return (React.createElement("div", Object.assign({ className: classes }, props), elements));
};
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map